module.exports = __webpack_public_path__ + "assets/images/dipiou.png?34fb4b33c73270119890bbf29aff60a6";


//////////////////
// WEBPACK FOOTER
// ./_source/images/logo/dipiou.png
// module id = 629
// module chunks = 0